import { ChannelsSection } from '../ChannelsSection'
import { GlobalButton } from '../GlobalButton'
import { LockedChannelsSection } from '../LockedChannelsSection'
import { MainNavigation } from '../MainNavigation'
import { SavedViewsSection } from '../SavedViewsSection'
import { UserMenu } from '../UserMenu'
import { useMobileSidebar } from './MobileSidebarContext'
import { MobileSidebarDrawerShell } from './MobileSidebarDrawerShell'

import type { JSX } from 'react'

export function MobileSidebarDrawer(): JSX.Element {
  const { navigationOpen, setNavigationOpen } = useMobileSidebar()

  return (
    <MobileSidebarDrawerShell
      open={navigationOpen}
      onOpenChange={setNavigationOpen}
      footer={<UserMenu />}
    >
      <GlobalButton />
      <MainNavigation />
      <SavedViewsSection />
      <ChannelsSection />
      <LockedChannelsSection />
    </MobileSidebarDrawerShell>
  )
}
